import { render, staticRenderFns } from "./igaog.vue?vue&type=template&id=05279c84&scoped=true"
import script from "./igaog.vue?vue&type=script&lang=js"
export * from "./igaog.vue?vue&type=script&lang=js"
import style0 from "./igaog.vue?vue&type=style&index=0&id=05279c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05279c84",
  null
  
)

export default component.exports